<template>
  <section id="section-1" class="content-current display-card">
    <div class="card-align">
      <div class="row" id="voucherdata">
        <p v-html="htmldata" ref="document"></p>
      </div>
      <!-- End row -->

      <div class="divider"></div>
      <div class="row">
        <div class="col-md-12 btn-align">
          <button type="submit" class="btn btn-primary" @click="print">چاپ </button>

          <button type="submit" class="btn btn-primary" @click="downloadPdf">
            خروجی PDF
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import store from "../../../../views/profile/store/index";

export default {
  name: "PdkNumber",
  store,
  components: {},
  data: function () {
    return {
      htmldata: "",
      reserveId: 0,
      path: "",
    };
  },

  mounted: function () {
    this.reserveId = this.$route.params.id;
    this.getHtmlReserveData();
  },
  methods: {
    getHtmlReserveData() {
      this.$store
        .dispatch("getHotelCrsBookingVoucher", {
          reserveId: this.reserveId,
          sourceId: localStorage.getItem("SourceIdInReport"),
        })
        .then((res) => {
          this.htmldata = res.voucher;
        });
    },
    downloadPdf() {
      this.getPdfExport();
    },
    getPdfExport() {
      this.$store
        .dispatch("getHotelCrsPdf", {
          reserveId: this.reserveId,
          sourceId: localStorage.getItem("SourceIdInReport"),
        })
        .then((res) => {
          this.path = res.data;

          window.open(this.path);
        });
    },
    print() {
      this.$htmlToPaper("voucherdata");
    },
  },
};
</script>

<style lang="css" scoped>
.card-align {
  display: table !important;
  text-align: center;
  margin-top: 35px;
}
.display-card {
  display: table;
}
</style>